import { Component, ViewChild, Input, Optional, Inject, AfterViewInit } from '@angular/core';
import { IContextService, AccountContextValue, DomainContext, GroupContextValue, CoreConstants, LogService } from '@pershing/pershing-core';
import { NxiRestService } from '../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';
import { PortalComponentConstants } from '../utils/portal-component.constants';
import { Location } from '@angular/common';
@Component({
    selector: 'account-picker',
    templateUrl: './account-picker.component.html',
    styleUrls: ['./account-picker.component.css']
})
export class AccountPickerComponent implements AfterViewInit {
    public accountsList: any = null;
    private toSelect: any;
    private selectedContextValue: any = {};
    private selectedContextDomain: string = '';
    noAccount: boolean;
    singleAccount: boolean;
    ibd: string;
    multiAccounts: boolean;
    addLongDisplayClass: boolean = false;
    private defaultContext: String;
    title: string;
    isAdaTheme: boolean = false;
    isMobileTheme: boolean = false;
    private ALL_ACCOUNTS: string = 'ALL_ACCOUNTS';
    isGroupFunctionality: boolean = false;
    isModern: boolean = false;
    // default values set to false.
    @Input() isManagedAccountsPage: boolean = false;
    @Input() isHouseHoldPage: boolean = false;
    @Input() isTrading: boolean = false;
    @Input() isTrading529: boolean = false;
    private ssoDefaultAccount: string;
    @ViewChild('accountSelect') select;
    constructor(private contextService: IContextService, private nxiRestService: NxiRestService,
                private location: Location, private translationService: PershingTranslationService,
                private logService: LogService, @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portal-common', 'node_modules/@pershing/nxi-ng-portal-common/lib');
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'account-picker';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobileTheme = true;
        }
        if (appSettings.ssoDefaultLandingAccount) {
            this.ssoDefaultAccount = appSettings.ssoDefaultLandingAccount;
            appSettings.ssoDefaultLandingAccount = '';
        }
        this.isModern = appSettings.isModernTheme;
        this.ibd = appSettings.ibdConfigMap.IBD;
    }

    ngOnInit() {
        let url = this.location.path(false);
        let urlArray = url.split('/');
        let page =  urlArray[urlArray.length - 1].split('?')[0];
        if (PortalComponentConstants.isGroupFunctionality.indexOf(page) !== -1) {
            this.isGroupFunctionality = true;
        }
    }
    selectedAccount(event, contextObject) {
        if (event.source.selected) {
            if (this.selectedContextValue != null) {
                this.defaultContext = this.selectedContextValue.hashValue;
            }
            if (this.defaultContext !== contextObject.acctReference) {
                this.setDomainContext(contextObject);
            }
        }
    }
    // The below was done in ngOnInit
    // Variables injected via viewChild will be filled and available only after AfterViewInit lifecycle
    ngAfterViewInit() {
        this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = domainContext.value;
            this.selectedContextValue = contextValue;
            this.selectedContextDomain = domainContext.domain;
        });
        /* Fetch the roles on service initialization */
        this.nxiRestService.fetchUserAccounts(this.isManagedAccountsPage, this.isHouseHoldPage, this.isTrading, this.isTrading529).subscribe(data => {
            this.accountsList = data;
            let act = this.accountsList.find(c => c.acctNo === 'ALL');
            if (act) {
                let index = this.accountsList.indexOf(act);
                this.translationService.get('NXI_PORTAL_COMPONENTS.ALL_ACCOUNTS').subscribe(
                 res => {
                    act.displayLabel = res;
                });
                this.accountsList.splice(index, 1, act);
            }
            if (this.select && this.accountsList.length > 0) {
                if (this.isGroupFunctionality) {
                    let acctList = [];
                    for (let i = 0; i < this.accountsList.length; i++) {
                        if (!this.accountsList[i].group) {
                            acctList.push(this.accountsList[i]);
                        }
                    }
                    this.accountsList = acctList;
                }
                if (this.ssoDefaultAccount) {
                    for (let indvAccount of this.accountsList) {
                        if (indvAccount.acctNo === this.ssoDefaultAccount) {
                          this.setDomainContext(indvAccount);
                          this.toSelect = indvAccount;
                          break;
                        }
                    }
                }

                if (this.accountsList.length === 1) {
                    this.singleAccount = true;
                    this.noAccount = false;
                    this.setDomainContext(this.accountsList[0]);
                } else if (this.accountsList.length > 1) {
                    this.multiAccounts = true;
                    this.noAccount = false;
                } else if (this.accountsList.length === 0 ) {
                    this.noAccount = true;
                }
                if (this.selectedContextValue) {
                    console.log('selectedContextValue accountNumber ', this.selectedContextValue.accountNumber);
                    if (this.selectedContextDomain === CoreConstants.ACCOUNT) {
                        if (this.selectedContextValue.accountNumber === this.ALL_ACCOUNTS && this.isManagedAccountsPage) {
                            this.setDomainContext(this.accountsList[0]);
                            this.toSelect = this.accountsList.find(c => c.acctNo === this.accountsList[0].acctNo);
                        } else if (this.selectedContextValue.accountNumber === this.ALL_ACCOUNTS && !this.isHouseHoldPage) {
                            // If the slected account is all account then set the value. since always all accounts
                            // doesnt come in first when the default group is selected.This condition will get throgh
                            // and set the case.
                            this.toSelect = this.accountsList.find(c => c.acctNo === 'ALL');
                        } else {
                            this.toSelect = this.accountsList.find(c => c.group && c.acctNo !== 'ALL' ? c.groupId === this.selectedContextValue.accountNumber :
                                c.acctNo === this.selectedContextValue.accountNumber);
                        }
                    } else if (this.selectedContextDomain === CoreConstants.GROUP) {
                        this.toSelect = this.accountsList.find(c => c.groupId === this.selectedContextValue.groupId);
                    }
                } else {
                    if (this.isManagedAccountsPage) {
                        this.setDomainContext(this.accountsList[0]);
                        this.toSelect = this.accountsList.find(c => c.acctNo === this.accountsList[0].acctNo);
                    } else {
                        this.toSelect = this.accountsList.find(c => c.defaultGroup);
                    }
                }
                if (this.toSelect && !this.isTrading && !this.isTrading529) {
                    this.select.value = this.toSelect;
                } else if (!this.toSelect && !this.isTrading && !this.isTrading529) {
                    if (this.selectedContextValue && this.selectedContextValue.accountNumber === this.ALL_ACCOUNTS && !this.isGroupFunctionality) {
                        // If the slected account is all account then set the value. since always all accounts
                        // doesnt come in first when the default group is selected.This condition will get throgh
                        // and set the case.
                        this.toSelect = this.accountsList.find(c => c.acctNo === 'ALL');
                        this.select.value = this.toSelect;
                    } else {
                        this.toSelect = this.accountsList[0];
                        this.select.value = this.toSelect;
                    }
                }
                let displayAccount = this.accountsList.find(indvAcct => indvAcct.displayLabel.length > 32);
                if (displayAccount) {
                    this.addLongDisplayClass = true;
                }
            }
            let displayAccount = this.accountsList.find(indvAcct => indvAcct.displayLabel.length > 32);
            if (displayAccount) {
                this.addLongDisplayClass = true;
            }
        },
            error => {
                this.logService.error('Error while retrieving the account', error);
                this.noAccount = true;
            });
    }
    isAllAccounts(accountNumber: string): boolean {
        return accountNumber === 'ALL' || accountNumber === this.ALL_ACCOUNTS;
    }
    setDomainContext(contextObject: any) {
        if(this.isModern) {            
            if (contextObject.group) {
                // Group Handling
                let groupContextValue: GroupContextValue = new GroupContextValue(contextObject.groupId);
                groupContextValue.hashValue = contextObject.acctReference;
                groupContextValue.groupType = contextObject.acctTypeCode;
                groupContextValue.groupGUID = this.ibd + '_' + groupContextValue.groupGUID + '_' + (!!groupContextValue.groupType ? groupContextValue.groupType : 'C');;
                this.updateDomainContext(CoreConstants.GROUP, groupContextValue);
            } else {
                let accountContextValue: AccountContextValue = new AccountContextValue(contextObject);
                accountContextValue.accountNumber = contextObject.acctNo;
                accountContextValue.hashValue = contextObject.acctReference;
                accountContextValue.accountType = contextObject.acctTypeCode;
                this.updateDomainContext(CoreConstants.ACCOUNT, accountContextValue);
            }
        } else {            
            if (contextObject.group && !this.isAllAccounts(contextObject.acctNo)) {
                // Group Handling
                let groupContextValue: GroupContextValue = new GroupContextValue(contextObject.groupId);
                groupContextValue.hashValue = contextObject.acctReference;
                groupContextValue.groupType = contextObject.acctTypeCode;
                groupContextValue.groupGUID = contextObject.groupId;
                this.updateDomainContext(CoreConstants.GROUP, groupContextValue);
            } else {
                let accountContextValue: AccountContextValue = new AccountContextValue(contextObject);
                if (contextObject.acctNo === 'ALL') {
                    accountContextValue.accountNumber = this.ALL_ACCOUNTS;
                } else {
                    accountContextValue.accountNumber = contextObject.acctNo;
                    accountContextValue.accessCategoryCd = contextObject.acctRegTypeCode;
                }
                accountContextValue.hashValue = contextObject.acctReference;
                accountContextValue.accountType = contextObject.acctTypeCode;
                this.updateDomainContext(CoreConstants.ACCOUNT, accountContextValue);
            }
        }
        // this.setDomainContext(event.source.value, groupId);
        // this.contextService.saveLocalStorage();
    }
    // setDomainContext(value: any, groupId?: string) {
    //     if (value.group && value.acctNo !== 'ALL') {
    //         // Group Handling
    //         let groupContextValue: GroupContextValue = new GroupContextValue(groupId);
    //         groupContextValue.hashValue = value.acctReference;
    //         groupContextValue.groupType = value.acctTypeCode;
    //         groupContextValue.groupGUID = groupId;
    //         this.contextService.setDomainContext(CoreConstants.GROUP, groupContextValue);
    //     } else {
    //         let accountContextValue: AccountContextValue = new AccountContextValue(value);
    //         if (value.acctNo === 'ALL') {
    //             accountContextValue.accountNumber = this.ALL_ACCOUNTS;
    //         } else {
    //             accountContextValue.accountNumber = value.acctNo;
    //         }
    //         accountContextValue.hashValue = value.acctReference;
    //         accountContextValue.accountType = value.acctTypeCode;
    //         this.contextService.setDomainContext(CoreConstants.ACCOUNT, accountContextValue);
    //     }
    // }
    updateDomainContext(contextType: any, contextValue: any) {
        // this.setDomainContext(value);
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (this.defaultContext && urlArray[urlArray.length - 1].split('?').length > 1) {
            let queryparam = urlArray[urlArray.length - 1].split('?')[1];
            if (queryparam) {
                let page = '/';
                for (let i = 1; i < urlArray.length; i++) {
                    if (i !== urlArray.length - 1) {
                        page = page + urlArray[i] + '/';
                    } else {
                        if (urlArray[i].includes(queryparam)) {
                            page = page + urlArray[i].replace('?' + queryparam, '');
                        }
                    }
                }
                document.dispatchEvent(new CustomEvent('portal.gotoview', {
                    detail: {
                        'gotoPage': page,
                        'context': { 'domain': contextType, 'value': contextValue }
                    }
                }));
            }
        } else {
            this.contextService.setDomainContext(contextType, contextValue);
        }
    }
}
